import React, { FC } from 'react';
import { targetLinkdsk } from '../../../utils/targetDskLink';
import RoutableSitecoreLink from '../../@shared/routableSitecoreLink';
import { TPrimaryButton } from '../types/productSeriesDetailTestimonial.types';

const PrimaryButton: FC<TPrimaryButton> = (props) => {
  const { showPrimaryButton, buttonPrimary, isDesktop } = props;
  if (!showPrimaryButton) return null;
  return (
    <div className="testimonial-card__primary-btn">
      <RoutableSitecoreLink field={buttonPrimary} target={targetLinkdsk(buttonPrimary, isDesktop)}>
        {buttonPrimary.value.title}{' '}
      </RoutableSitecoreLink>
    </div>
  );
};

export default PrimaryButton;
